const ITEMS = [
  "Check Engine Light Diagnostics",
  "Alternators & Starters",
  "Water Pumps & Radiators",
  "Tune-ups & Brakes",
  "Emergency Roadside Jump Starts & Batteries",
];

function Track() {
  return (
    <div className="flex items-center gap-10 pr-10">
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center gap-10">
          <span>{item}</span>
          <span className={i % 2 === 0 ? "text-[#ff4b2b]" : "text-[#00e5ff]"}>&#9733;</span>
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <section
      data-testid="services-marquee"
      className="border-b border-white/10 bg-[#080d15] py-4 overflow-hidden"
    >
      <div className="mq-track font-mono-lbl text-xs uppercase tracking-widest text-slate-400">
        <Track />
        <Track />
      </div>
    </section>
  );
}
